import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';

import { ConfigurationService } from '../core/configuration.service';
import { Constants } from '../core/constants';
import { CustomerPhotoDialogComponent } from '../payout/customer.photo.dialog.component';

@Injectable()
export class CustomerService {
  private baseApiUrl: string;
  private customerPreviewUrl: string;
  private documentPreviewUrl: string;

  constructor(configurationService: ConfigurationService,
    private httpClient: HttpClient,
    private dialog: MatDialog,
    private constants: Constants) {
    this.baseApiUrl = configurationService.BaseApiUrl;
    this.customerPreviewUrl = `${configurationService.BasePreviewUrl}customer/`;
    this.documentPreviewUrl = `${configurationService.BasePreviewUrl}document/`;
  }

  // getFilteredCustomers(filter: string, searchType: number, pageIndex: number, pageSize: number,
  //   sortColumn: string, sortAscending: boolean, isMaintenance: boolean = false): Observable<any> {

  //   const params = {
  //     filter, searchType, pageIndex, pageSize, sortColumn, sortAscending, isMaintenance
  //   };

  //   return this.httpClient.post(this.baseApiUrl + 'customer/filter', params).pipe(
  //     map((res: any) => res),
  //     catchError((err: any) => observableThrowError(err.message || 'Server error')));
  // }

  //   getFilteredCustomers(filter: string, searchType: number, pageIndex: number, pageSize: number,
  //   sortColumn: string, sortAscending: boolean, isMaintenance: boolean = false,accountType: boolean = false, type: number = -1): Observable<any> {

  //   const params = {
  //     filter, searchType, pageIndex, pageSize, sortColumn, sortAscending, isMaintenance,accountType,type
  //   };

  //   return this.httpClient.post(this.baseApiUrl + 'customer/filter', params).pipe(
  //     map((res: any) => res),
  //     catchError((err: any) => observableThrowError(err.message || 'Server error')));
  // }
   getFilteredCustomers(filter: string, searchType: number, pageIndex: number, pageSize: number,
    sortColumn: string, sortAscending: boolean, isMaintenance: boolean = false,accountType: boolean = false, type: number = -1): Observable<any> {

    const params = {
      filter, searchType, pageIndex, pageSize, sortColumn, sortAscending, isMaintenance,accountType,type
    };

    return this.httpClient.post(this.baseApiUrl + 'customer/filter', params).pipe(
      map((res: any) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }
  getAllCustomers(): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + 'customer').pipe(
      map((res: any) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

   
  
  getCustomer(id: number, forMaintenance: boolean = false): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `customer/${id}?isMaintenance=${forMaintenance}`).pipe(
      map((res: Response) => this.addCustomerDisplayData(res)),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getInterfaceReq(id: number): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `interfacemobilebanking/mobilebankingrequest/${id}`).pipe(
      map((res: Response) => this.addInterfaceCustomerDisplayData(res)),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getCustomerByIdentifier(identifier: string, forMaintenance: boolean = false): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `customer/identifier/${identifier}?isMaintenance=${forMaintenance}`).pipe(
      map((res: Response) => this.addCustomerDisplayData(res)),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getMembership(customerIdentifier: string): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `customer/membership/${customerIdentifier}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  createCustomer(customer: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'customer', customer).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  updateCustomer(customer: any): Observable<any> {
    return this.httpClient.put(this.baseApiUrl + 'customer', customer).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  createInterfaceCustomer(customer: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'interfacemobilebanking/approverejectkyc', customer).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  authorise(id: number): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'customer/authorise', id).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  delete(id: number): Observable<any> {
    return this.httpClient.delete(this.baseApiUrl + `customer/${id}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  checkDuplicateIdentity(identityNumber: string): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'customer/duplicate', { identityNumber } ).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getDocumentContentAsDataUrl(id: number, forMaintenance: boolean = false): Observable<any> {
    return this.httpClient.get(`${this.documentPreviewUrl}${id}?isMaintenance=${forMaintenance}`, { responseType: 'text' }).pipe(
      map(res => ({ id, dataUrl: res })),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getPhotoAsDataUrl(customerId: number): Observable<any> {
    const url = `${this.customerPreviewUrl}${customerId}?documentType=${this.constants.ProofOfIdentity.Photo}`;

    return this.httpClient.get(url, { responseType: 'text' }).pipe(
      map(res => ({ customerId, dataUrl: res })),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getSignatureAsDataUrl(customerId: number): Observable<any> {
    const url = `${this.customerPreviewUrl}${customerId}?documentType=${this.constants.ProofOfIdentity.Signature}`;

    return this.httpClient.get(url, { responseType: 'text' }).pipe(
      map(res => ({ customerId, dataUrl: res })),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }
  
  submitCustomerFeedback(feedbackData: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'customer/customerfeedback', feedbackData).pipe(
      map((res: any) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error'))
    );
  }


  addCustomerDisplayData(customer: any): any {
    let mobileNumber = '';
    let panNumber = '';
    let aadhaarNumber = '';
    customer.phoneNumbers.forEach(mobile => {
      if (mobile.phoneType === this.constants.PhoneType.MobileNumber) {
        mobileNumber = mobile.phoneNumber;
      }
    });
    customer.identityProofs.forEach(pan => {
      if (pan.idProofType === this.constants.ProofOfIdentity.PANCard) {
        panNumber = pan.idNumber;
      }
    });
    customer.identityProofs.forEach(aadhaar => {
      if (aadhaar.idProofType === this.constants.ProofOfIdentity.Aadhaar) {
        aadhaarNumber = aadhaar.idNumber;
      }
    });

    const addressTypeList = [];
    if (customer.addresses.length > 0) {
      customer.addresses.forEach(address => {
        if (customer.id === address.customerId) {
          addressTypeList.push({
            id: address.id,
            name: this.getAddress(address)
          });
        }
      });
    }
    customer.phoneNumber = mobileNumber;
    customer.addressTypeList = addressTypeList;
    customer.displayData = `${customer.customerName}`
      + ` - ${customer.customerIdentifier} - ${aadhaarNumber} - ${panNumber} - ${mobileNumber}`;
    return customer;
  }
  
  addInterfaceCustomerDisplayData(customer: any): any {
    let mobileNumber = '';
    let panNumber = '';
    let aadhaarNumber = '';
    customer.payload.phoneNumbers.forEach(mobile => {
      if (mobile.phoneType === this.constants.PhoneType.MobileNumber) {
        mobileNumber = mobile.phoneNumber;
      }
    });
    customer.payload.identityProofs.forEach(pan => {
      if (pan.idProofType === this.constants.ProofOfIdentity.PANCard) {
        panNumber = pan.idNumber;
      }
    });
    customer.payload.identityProofs.forEach(aadhaar => {
      if (aadhaar.idProofType === this.constants.ProofOfIdentity.Aadhaar) {
        aadhaarNumber = aadhaar.idNumber;
      }
    });

    const addressTypeList = [];
    if (customer.payload.addresses.length > 0) {
      customer.payload.addresses.forEach(address => {
        if (customer.id === address.customerId) {
          addressTypeList.push({
            id: address.id,
            name: this.getAddress(address)
          });
        }
      });
    }
    customer.payload.phoneNumber = mobileNumber;
    customer.payload.addressTypeList = addressTypeList;
    customer.payload.displayData = `${customer.payload.customerName}`
      + ` - ${customer.payload.customerIdentifier} - ${aadhaarNumber} - ${panNumber} - ${mobileNumber}`;
    return customer.payload;
  }


  getAddress(address): string {
    return `${this.getAddressType(address.addressType)}` +
         ` - ${address.line1} ${address.line2} ${address.line3} ${address.city} ${address.district}`;
  }
  getAddressType(type): string {
    console.log('address type', type);
    switch (type) {
      case this.constants.AddressTypes.ResidentialBusiness:
        return this.constants.AddressTypeNames.ResidentialBusiness;
      case this.constants.AddressTypes.Residential:
        return this.constants.AddressTypeNames.Residential;
      case this.constants.AddressTypes.Business:
        return this.constants.AddressTypeNames.Business;
      case this.constants.AddressTypes.RegisteredOffice:
        return this.constants.AddressTypeNames.RegisteredOffice;
      case this.constants.AddressTypes.Unspecified:
        return this.constants.AddressTypeNames.Unspecified;
    }
  }

  getAge(dateOfBirth: Date, openingDate: Date): any {
    const openDate = new Date(openingDate);
    const birthDate = new Date(dateOfBirth);
    let diffYears = openDate.getFullYear() - birthDate.getFullYear();
    const diffMonths = openDate.getMonth() - birthDate.getMonth();
    if (diffMonths < 0 || (diffMonths === 0 && openDate.getDate() < birthDate.getDate())) {
      diffYears = diffYears - 1;
    }
    const majorityDate = new Date(dateOfBirth);
    majorityDate.setFullYear(majorityDate.getFullYear() + 18);
    return { age: diffYears, majorityDate: majorityDate };
  }

  showPhoto(customerId: number, customerName: string) {
    this.getPhotoAsDataUrl(customerId)
      .subscribe(result => {
        console.log('photos of customer', result);
        this.dialog.open(CustomerPhotoDialogComponent, {
          width: '30%',
          maxHeight: '100vh',
          data: {
            description: `Photo of ${customerName}`,
            imageContent: result.dataUrl
          }
        });
      },
        err => console.log('Failed to get customer photo', err));
  }

   getFeedbackByAccountId(generalLedgerId: number, accountId: number): Observable<any> {
    return this.httpClient.get(`${this.baseApiUrl}customer/getcustomerfeedbackbyaccountid/${accountId}?generalLedgerId=${generalLedgerId}`).pipe(
      map((res: any) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error'))
    );
  }

  

   getFeedbackByCustomerId(customerId: number): Observable<any> {
    return this.httpClient.get(`${this.baseApiUrl}customer/getcustomerfeedbackbycustomerid/${customerId}`).pipe(
      map((res: any) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error'))
    );
  }

  showSignature(customerId: number, customerName: string) {
    this.getSignatureAsDataUrl(customerId)
      .subscribe(result => {
        this.dialog.open(CustomerPhotoDialogComponent, {
          width: '30%',
          maxHeight: '100vh',
          data: {
            description: `Signature of ${customerName}`,
            imageContent: result.dataUrl
          }
        });
      },
        err => console.log('Failed to get customer signature', err));
  }

}
